import React from "react";

const Invitations = () => {
    return <div>Invitations</div>
}
export default Invitations;